import React from 'react';
import Cono from "./../img/MenuComponents/cono.png"
import "./../css/MenuComponent.css"

function MenuComponent({productos, titulo, subTitulo}) {

    return (
      <section className='menuComponent'>
        <img src={Cono} className='menuComponent__icono'/>
        <h2 className='menuComponent__titulo'>
          - {titulo} -
        </h2>
        <p className='menuComponent__subTitulo'>
          {subTitulo}
        </p>
        <div className='menuComponent__productos'>
          {productos.map((prod, index)=>
          <div className='menuComponent__productos__caja'>
            <h4>
              {prod.nombre}
            </h4> 
            <p>
              {prod.descripcion}
            </p>         
          </div>
        )}          
        </div>

      </section>
    );
  }
  
  export default MenuComponent;